import React from 'react';

class Form extends React.Component {

  render() {
    return (
      <div className={`bg-near-white t-mt2 t-pa1 ${this.props.opened ? 'a-reply-input' : ''}`}>
        <form className="flex items-center justify-between input-reset " onSubmit={this.props.submit.bind(this)}>
          <input type="hidden" name="form-name" value="form 2" />
          <div className="relative w-60">
            <input
              className="f--2 lh-title t-pa1 fw3 w-100"
              type="text"
              name="body"
              ref="body_input"
              placeholder={I18n.t('components.reply_form.placeholder')}
              autoFocus
              onFocus={moveCaretAtEnd}
              defaultValue={this.props.form.body}
              onKeyUp={this.props.handleInputChange}
              onClick={this.props.onInputClick}
            />
          </div>
          <div className="t-pl1 f--2">
            <a
              className="bg-yellow-2 border-none a-font-size-2 white rounded cursor-pointer a-post-comment-button"
              onClick={this.props.submit.bind(this)}
            >
              {I18n.t('components.webreader_comments_list.submit_comment')}
            </a>
          </div>
          <div className={`t-pl1 f--3 ttu ${this.props.hideCancelButton?'invisible':''}`}>
            <a
              className="link blue fw4"
              href={EMPTY_HREF}
              onClick={ (event) => {
                event.preventDefault();
                this.props.closeForm();
              }}
            >
              {I18n.t('components.webreader_reports_menu.cancel')}
            </a>
          </div>
        </form>
      </div>
    )
  }
}

Form.defaultProps = {
  onInputClick: () => {return false}
};

export default Form;